import { render, staticRenderFns } from "./ForgotUsernameConfirmIdentity.vue?vue&type=template&id=6dc6d087&"
import script from "./ForgotUsernameConfirmIdentity.vue?vue&type=script&lang=ts&"
export * from "./ForgotUsernameConfirmIdentity.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports